// extracted by mini-css-extract-plugin
export default {"root":"PageNotFound_root__PgeBn","imgStyle":"PageNotFound_imgStyle__PTQMI","heading":"PageNotFound_heading__yo28Y","subHeading":"PageNotFound_subHeading__RYrI1"};